import useFiltersStore from '../store/useFiltersStore';
import { lotsStore } from '../store/useLotsStore';
import useSortStore from '../store/useSortStore';
import { polygonsStore } from '../store/usePolygonsStore';
import { sortFilteredLots } from './sort';
import { doesPolygonShowAvailable, mapStatus } from './polygon';
import settings, { homeTypesMapping } from './config';
import { HomeTypes, LotStatuses } from '../types/filterAndSort';
import { CLOSE_DROPDOWN_EVENT_NAME } from './constants';
export function attachFilterStateListener() {
    const detachListeners = useFiltersStore.subscribe((state) => {
        filterLotsAndPolygons(state);
    });
    return detachListeners;
}
export function filterLotsAndPolygons(filterState) {
    // if filters are not being applied, don't calculate new filtered lots
    if (!filterState.applyFilterFlag) {
        return;
    }
    const polygonsCopy = polygonsStore.getState().polygons;
    const hasNonLotStatusFiltersApplied = filterState.hasNonLotStatusFiltersApplied();
    const lotsCopy = lotsStore.getState().lots.filter((lot) => {
        // get matching lot in polygon store and set default to hide on map
        const currentPolygonIndex = polygonsCopy.findIndex((polygon) => polygon.Properties.Id === lot.Properties.Id);
        polygonsCopy[currentPolygonIndex].hideOnMap = true;
        if (hasNonLotStatusFiltersApplied && !doesPolygonShowAvailable(lot)) {
            return false;
        }
        const quickMoveInCond = !filterState.quickMoveIn || lot.Properties.IsQuickMoveIn;
        const priceBoundsCond = lot.Properties.Price >= filterState.priceBounds.selectedMin &&
            lot.Properties.Price <= filterState.priceBounds.selectedMax;
        const bedsCond = lot.Properties.Beds >= filterState.beds;
        const bathsCond = lot.Properties.Baths >= filterState.baths;
        const homeTypesCond = filterState.homeTypes.length === 0 ||
            (lot.Properties.HomeType &&
                filterState.homeTypes.includes(lot.Properties.HomeType));
        const squareFeetBoundsCond = lot.Properties.SquareFootage >= filterState.squareFeetBounds.selectedMin &&
            lot.Properties.SquareFootage <= filterState.squareFeetBounds.selectedMax;
        const parkingBaysCond = lot.Properties.Bays >= filterState.parkingBays;
        const floorsCond = filterState.numberOfFloors.value === 0 ||
            lot.Properties.Floors >= filterState.numberOfFloors.value;
        const lotStatusesCond = filterState.lotStatuses.length === 0 ||
            (lot.Properties.LotStatus && filterState.lotStatuses.includes(mapStatus(lot)));
        if (quickMoveInCond &&
            priceBoundsCond &&
            bedsCond &&
            bathsCond &&
            homeTypesCond &&
            squareFeetBoundsCond &&
            parkingBaysCond &&
            floorsCond &&
            lotStatusesCond) {
            polygonsCopy[currentPolygonIndex].hideOnMap = false;
            // return available lots
            if (doesPolygonShowAvailable(lot)) {
                return true;
            }
        }
        return false;
    });
    polygonsStore.getState().setPolygons(polygonsCopy);
    lotsStore.getState().setFilteredLots(lotsCopy);
    useFiltersStore.getState().setApplyFilterFlag(false);
    // apply the same sort state
    const sortState = useSortStore.getState();
    sortFilteredLots(sortState.sortBy, sortState.sortDirection);
}
export function sendCloseDropdownEvent(sourceEl) {
    const breakpointEvent = new Event(CLOSE_DROPDOWN_EVENT_NAME, {
        bubbles: true
    });
    sourceEl.dispatchEvent(breakpointEvent);
}
export const homeTypeFilterInputs = [
    {
        value: homeTypesMapping[HomeTypes.SingleFamily],
        id: 'checkbox-single-family-home',
        label: settings.FilterHomeTypeSingleFamilyHomeLabel,
        checked: false
    },
    {
        value: homeTypesMapping[HomeTypes.Condominium],
        id: 'checkbox-condominium',
        label: settings.FilterHomeTypeCondominiumHomeLabel,
        checked: false
    },
    {
        value: homeTypesMapping[HomeTypes.Flat],
        id: 'checkbox-flat',
        label: settings.FilterHomeTypeFlatLabel,
        checked: false
    },
    {
        value: homeTypesMapping[HomeTypes.Town],
        id: 'checkbox-town-home',
        label: settings.FilterHomeTypeTownHomeLabel,
        checked: false
    },
    {
        value: homeTypesMapping[HomeTypes.Paired],
        id: 'checkbox-paired-home',
        label: settings.FilterHomeTypePairedHomeLabel,
        checked: false
    }
];
export const lotStatusFilterInputs = [
    {
        value: LotStatuses.Sold,
        id: 'checkbox-lot-status-sold',
        label: settings.StatusSoldLabel,
        checked: false
    },
    {
        value: LotStatuses.Model,
        id: 'checkbox-lot-status-model',
        label: settings.StatusModelLabel,
        checked: false
    },
    {
        value: LotStatuses.Unavailable,
        id: 'checkbox-lot-status-unavailable',
        label: settings.StatusUnavailableLabel,
        checked: false
    },
    {
        value: LotStatuses.UnderConstruction,
        id: 'checkbox-lot-status-under-construction',
        label: settings.StatusUnderConstructionLabel,
        checked: false
    },
    {
        value: LotStatuses.MoveInReady,
        id: 'checkbox-lot-status-move-in-ready',
        label: settings.StatusMoveInReadyLabel,
        checked: false
    },
    // {
    //   value: LotStatuses.Available,
    //   id: 'checkbox-lot-status-available',
    //   label: settings.StatusAvailableHomesiteLabel,
    //   checked: false
    // }
];
export const numberFloorsFilterOptions = [
    { value: 0, label: settings.FilterAnyLabel },
    { value: 1, label: '1' },
    { value: 2, label: '2' }
];
export const filterDefaults = {
    quickMoveIn: false,
    priceBounds: {
        selectedMin: settings.FilterMinPriceValue,
        selectedMax: settings.FilterMaxPriceValue
    },
    beds: 0,
    baths: 0,
    homeTypes: [],
    squareFeetBounds: {
        selectedMin: settings.FilterMinSquareFeetValue,
        selectedMax: settings.FilterMaxSquareFeetValue
    },
    parkingBays: 0,
    numberOfFloors: { value: 0, label: 'Any' },
    lotStatuses: []
};
